import React from 'react';
import { IValueCell } from './interfaces';
import { Box, Typography } from '@mui/material';

export const ValueCell: React.FC<IValueCell> = ({ value }): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
        }}
        title={value ?? '-'}
      >
        {value || '-'}
      </Typography>
    </Box>
  );
};
